import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { atcb_action } from "add-to-calendar-button";
import countriesWithTimezones from "../../helpers/countriesTimezone";
import { StyledAddToCalendar, StyledButton } from "./partials";
import IconV2 from "../icon-v2";

export interface AddToCalendarProps {
  label: string;
  calendar_types: string;
}

export const AddToCalendar: React.FC<AddToCalendarProps> = ({
  label,
  calendar_types,
}) => {
  const [results, setResults] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  let eventCookie = Cookies.get("event_info") + "-null";
  eventCookie = eventCookie.replace("eventId=", "");

  useEffect(() => {
    fetch(`${process.env.GATSBY_HULTEDUDATA_API}/events/search`, {
      method: "POST",
      body: JSON.stringify({
        filters: [],
        size: 100,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setResults(data.hits.hits);
        setLoading(false); // Update loading state
      });
  }, []);

  const matchingEvent = results.find((event) => event._id === eventCookie);


  const getTimezoneForCountry = (countryAbbreviation: string) => {
    return countriesWithTimezones[countryAbbreviation] || "";
  };

  let startTime = new Date(matchingEvent && matchingEvent._source.StartDatetime);
  let endTime = new Date(matchingEvent && matchingEvent._source.EndDatetime);

  function formatDate(d) {
    return d
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
  }

  const config = {
    name: `${matchingEvent && matchingEvent._source.Title}`,
    description: `${matchingEvent && matchingEvent._source.Description}`,
    options: calendar_types,
    location: `${matchingEvent && matchingEvent._source.Link}`,
    startDate: `${formatDate(startTime)}`,
    startTime: `${startTime.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,  // Use 24-hour format
    })}`,
    endDate: `${formatDate(endTime)}`,
    endTime: `${endTime.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,  // Use 24-hour format
    })}`,
    timeZone: `${matchingEvent && getTimezoneForCountry(matchingEvent._source.Country)}`,
    hideCheckmark: true,
  };

  return (
    <>
      {!loading && matchingEvent && (
        <StyledAddToCalendar>
          <StyledButton onClick={() => atcb_action(config)}>
            <p>{label}</p>
            <IconV2 icon={"calendar"} size={"16"} />
          </StyledButton>
        </StyledAddToCalendar>
      )}
    </>
  );
};
